import type { DiscountKind } from "@/features/discounts/api/types";

export const KIND_OPTIONS: { value: DiscountKind; label: string }[] = [
	{ value: "NATIONAL", label: "Національна" },
	{ value: "FAMILY", label: "Сімейна" },
	{ value: "CORPORATE", label: "Корпоративна" },
	{ value: "EVERYONE", label: "Для всіх" },
];

export function discountKindLabel(kind: DiscountKind): string {
	return KIND_OPTIONS.find((option) => option.value === kind)?.label ?? kind;
}
